import * as React from 'react';
import { useCallback } from 'react';
import classNames from 'classnames';
import { UIText2, UIText3 } from '@cian/ui-kit';
import { NBSP } from '../../../../../../../../constants/symbols';

import * as styles from './Duration.css';
import { getDurationText } from '../../utils';

export interface IDurationProps {
  duration: number;
  discount: number;
  checked: boolean;

  onClick({ duration, discount }: { duration: number; discount: number }): void;
}

export const Duration = ({ duration, discount, checked, onClick }: IDurationProps) => {
  const handleClick = useCallback(() => {
    onClick({ duration, discount });
  }, [discount, duration, onClick]);

  return (
    <div
      className={classNames(styles['card'], checked && styles['checked'])}
      onClick={handleClick}
      data-testid="duration"
    >
      <UIText2>{getDurationText(duration)}</UIText2>

      {Boolean(discount) && (
        <div className={styles.discount}>
          <UIText3 color="primary_100">
            Скидка{NBSP}
            {discount}%
          </UIText3>
        </div>
      )}
    </div>
  );
};
